function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1586 1703",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10.2089,-563.138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,143.249,302.722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.139,-16.14C-25.053,-16.14 -32.279,-8.914 -32.279,-0C-32.279,8.913 -25.053,16.139 -16.139,16.139C-7.227,16.139 0,8.913 0,-0C0,-8.914 -7.227,-16.14 -16.139,-16.14",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,237.885,301.989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.14,-16.139C-25.053,-16.139 -32.279,-8.913 -32.279,0C-32.279,8.914 -25.053,16.14 -16.14,16.14C-7.226,16.14 0,8.914 0,0C0,-8.913 -7.226,-16.139 -16.14,-16.139",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,189.466,303.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.139,-16.139C-25.053,-16.139 -32.278,-8.913 -32.278,0C-32.278,8.913 -25.053,16.139 -16.139,16.139C-7.225,16.139 0,8.913 0,0C0,-8.913 -7.225,-16.139 -16.139,-16.139",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,137.706,218.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,242.794C9.493,239.335 22.077,232.132 32.193,231.392C38.183,230.954 43.938,232.646 49.632,232.733C58.889,232.874 68.821,233.3 75.789,232.062C85.967,230.257 96.859,227.907 106.641,224.015C152.153,205.894 192.668,164.659 192.491,102.618C192.338,49.73 161.775,12.022 125.421,-9.39C104.513,-21.703 66.573,-32.021 33.536,-26.156C-29.883,-14.901 -82.672,33.039 -82.496,102.618C-82.398,141.128 -65.59,167.901 -48.29,188.468C-44.486,192.989 -32.172,201.606 -30.853,206.576C-26.802,221.821 -33.888,238.235 -30.853,254.866C-18.677,251.51 -10.293,246.544 0,242.794M42.925,-64.387L67.069,-64.387C158.655,-52.56 214.491,0.217 226.696,91.886L226.696,114.019C218.253,187.144 177.442,234.89 118.714,258.891C95.8,268.253 65.474,272.853 34.877,268.28C1.701,281.16 -31.397,294.115 -64.387,307.181C-65.618,293.529 -65.058,279.61 -65.058,265.598C-65.058,251.633 -62.08,235.701 -65.058,223.343C-65.738,220.521 -70.385,215.84 -73.777,211.942C-95.92,186.489 -112.998,157.22 -116.702,114.019L-116.702,91.216C-114.008,61.448 -102.499,29.265 -87.191,8.048C-58.639,-31.522 -16.386,-57.987 42.925,-64.387",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,137.706,218.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,242.794C9.493,239.335 22.077,232.132 32.193,231.392C38.183,230.954 43.938,232.646 49.632,232.733C58.889,232.874 68.821,233.3 75.789,232.062C85.967,230.257 96.859,227.907 106.641,224.015C152.153,205.894 192.668,164.659 192.491,102.618C192.338,49.73 161.775,12.022 125.421,-9.39C104.513,-21.703 66.573,-32.021 33.536,-26.156C-29.883,-14.901 -82.672,33.039 -82.496,102.618C-82.398,141.128 -65.59,167.901 -48.29,188.468C-44.486,192.989 -32.172,201.606 -30.853,206.576C-26.802,221.821 -33.888,238.235 -30.853,254.866C-18.677,251.51 -10.293,246.544 0,242.794ZM42.925,-64.387L67.069,-64.387C158.655,-52.56 214.491,0.217 226.696,91.886L226.696,114.019C218.253,187.144 177.442,234.89 118.714,258.891C95.8,268.253 65.474,272.853 34.877,268.28C1.701,281.16 -31.397,294.115 -64.387,307.181C-65.618,293.529 -65.058,279.61 -65.058,265.598C-65.058,251.633 -62.08,235.701 -65.058,223.343C-65.738,220.521 -70.385,215.84 -73.777,211.942C-95.92,186.489 -112.998,157.22 -116.702,114.019L-116.702,91.216C-114.008,61.448 -102.499,29.265 -87.191,8.048C-58.639,-31.522 -16.386,-57.987 42.925,-64.387Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 9
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msg_icon.a2f3229829c455dfc26112446f3609fe.svg";
export { ForwardRef as ReactComponent };